import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';
import { UserCache } from '../../model/UserCache';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private static VERSION = '1.1';

  constructor(private readonly http: HttpClient) {}

  getUserCache(): UserCache {
    const user = localStorage.getItem('currentUser');
    if (!user) {
      return null;
    }
    try {
      const username = JSON.parse(user).username;
      return JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem(this.getUsername(username, true)).toString(),
          username,
        ).toString(CryptoJS.enc.Utf8),
      );
    } catch (e) {
      return null;
    }
  }

  setUserCache(cache: UserCache) {
    if (!cache.user) {
      return;
    }
    localStorage.setItem(
      this.getUsername(cache.user.username, true),
      CryptoJS.AES.encrypt(
        JSON.stringify(cache),
        cache.user.username,
      ).toString(),
    );
    // localStorage.setItem(this.getUsername(cache.user.username, true), JSON.stringify(cache));
  }

  getUsername(username: string, hashed: boolean = false): string {
    return hashed
      ? CryptoJS.MD5(username + '_' + SessionService.VERSION).toString()
      : localStorage.getItem('username');
  }

  logout() {
    return this.http.post('/api/authentication/signout', {});
  }
}
